import type { FC } from "react"
import { useMemo } from "react"

import { useTestTemplateColumns } from "../../hooks"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { TestTemplate } from "@/graphql/codegen/graphql"

interface TestTemplateSelectTableProps {
  testTemplates: TestTemplate[]
  onTestTemplateSelect: (testTemplateId: string | null) => void
  selectedTestTemplate: TestTemplate | null
  isFetching: boolean
}

export const TestTemplateSelectTable: FC<TestTemplateSelectTableProps> = ({
  testTemplates,
  onTestTemplateSelect,
  selectedTestTemplate,
  isFetching,
}) => {
  const rowSelection = useMemo(() => {
    return selectedTestTemplate ? { [selectedTestTemplate.testTemplateId]: true } : {}
  }, [selectedTestTemplate])

  const handleRowSelectionChange = (updater: any) => {
    if (typeof updater === "function") {
      const newSelection = updater(rowSelection)
      const keys = Object.keys(newSelection)
      if (keys.length > 1) {
        const lastKey = keys[keys.length - 1]
        onTestTemplateSelect(lastKey)
      } else {
        onTestTemplateSelect(keys[0] || null)
      }
    }
  }

  return (
    <AerosBaseTable
      slotProps={{
        bodyCellExpanded: { className: "bg-primary-100" },
      }}
      features={{
        tanstackOptions: {
          data: testTemplates,
          columns: useTestTemplateColumns,
          onRowSelectionChange: handleRowSelectionChange,
          getRowId: (row) => row?.testTemplateId,
          state: { rowSelection, isLoading: isFetching },
          enableRowSelection: (row) => !row.original.isAssociatedWithProduct,
        },
      }}
      noDataMessage='No test templates found'
    />
  )
}
